"use strict";

var _regeneratorRuntime = require("/opt/build/repo/graphiclab/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/opt/build/repo/graphiclab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/graphiclab/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Utils = void 0;

var OutModeDirection_1 = require("../Enums/Directions/OutModeDirection");

var NumberUtils_1 = require("./NumberUtils");

function rectSideBounce(pSide, pOtherSide, rectSide, rectOtherSide, velocity, factor) {
  var res = {
    bounced: false
  };

  if (pOtherSide.min >= rectOtherSide.min && pOtherSide.min <= rectOtherSide.max && pOtherSide.max >= rectOtherSide.min && pOtherSide.max <= rectOtherSide.max) {
    if (pSide.max >= rectSide.min && pSide.max <= (rectSide.max + rectSide.min) / 2 && velocity > 0 || pSide.min <= rectSide.max && pSide.min > (rectSide.max + rectSide.min) / 2 && velocity < 0) {
      res.velocity = velocity * -factor;
      res.bounced = true;
    }
  }

  return res;
}

function checkSelector(element, selectors) {
  if (selectors instanceof Array) {
    var _iterator = _createForOfIteratorHelper(selectors),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var selector = _step.value;

        if (element.matches(selector)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  } else {
    return element.matches(selectors);
  }
}

var Utils = /*#__PURE__*/function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }

  _createClass(Utils, null, [{
    key: "isSsr",
    value: function isSsr() {
      return typeof window === "undefined" || !window;
    }
  }, {
    key: "isInArray",
    value: function isInArray(value, array) {
      return value === array || array instanceof Array && array.indexOf(value) > -1;
    }
  }, {
    key: "loadFont",
    value: function loadFont(character) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return document.fonts.load("".concat(character.weight, " 36px '").concat(character.font, "'"));

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));
    }
  }, {
    key: "arrayRandomIndex",
    value: function arrayRandomIndex(array) {
      return Math.floor(Math.random() * array.length);
    }
  }, {
    key: "itemFromArray",
    value: function itemFromArray(array, index) {
      var useIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var fixedIndex = index !== undefined && useIndex ? index % array.length : Utils.arrayRandomIndex(array);
      return array[fixedIndex];
    }
  }, {
    key: "isPointInside",
    value: function isPointInside(point, size, radius, direction) {
      return Utils.areBoundsInside(Utils.calculateBounds(point, radius !== null && radius !== void 0 ? radius : 0), size, direction);
    }
  }, {
    key: "areBoundsInside",
    value: function areBoundsInside(bounds, size, direction) {
      var inside = true;

      if (!direction || direction === OutModeDirection_1.OutModeDirection.bottom) {
        inside = bounds.top < size.height;
      }

      if (inside && (!direction || direction === OutModeDirection_1.OutModeDirection.left)) {
        inside = bounds.right > 0;
      }

      if (inside && (!direction || direction === OutModeDirection_1.OutModeDirection.right)) {
        inside = bounds.left < size.width;
      }

      if (inside && (!direction || direction === OutModeDirection_1.OutModeDirection.top)) {
        inside = bounds.bottom > 0;
      }

      return inside;
    }
  }, {
    key: "calculateBounds",
    value: function calculateBounds(point, radius) {
      return {
        bottom: point.y + radius,
        left: point.x - radius,
        right: point.x + radius,
        top: point.y - radius
      };
    }
  }, {
    key: "loadImage",
    value: function loadImage(source) {
      return new Promise(function (resolve, reject) {
        if (!source) {
          reject("Error tsParticles - No image.src");
          return;
        }

        var image = {
          source: source,
          type: source.substr(source.length - 3)
        };
        var img = new Image();
        img.addEventListener("load", function () {
          image.element = img;
          resolve(image);
        });
        img.addEventListener("error", function () {
          reject("Error tsParticles - loading image: ".concat(source));
        });
        img.src = source;
      });
    }
  }, {
    key: "downloadSvgImage",
    value: function downloadSvgImage(source) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var image, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (source) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Error tsParticles - No image.src");

              case 2:
                image = {
                  source: source,
                  type: source.substr(source.length - 3)
                };

                if (!(image.type !== "svg")) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", Utils.loadImage(source));

              case 5:
                _context2.next = 7;
                return fetch(image.source);

              case 7:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 10;
                  break;
                }

                throw new Error("Error tsParticles - Image not found");

              case 10:
                _context2.next = 12;
                return response.text();

              case 12:
                image.svgData = _context2.sent;
                return _context2.abrupt("return", image);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "deepExtend",
    value: function deepExtend(destination) {
      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
      }

      for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
        var source = _sources[_i];

        if (source === undefined || source === null) {
          continue;
        }

        if (typeof source !== "object") {
          destination = source;
          continue;
        }

        var sourceIsArray = Array.isArray(source);

        if (sourceIsArray && (typeof destination !== "object" || !destination || !Array.isArray(destination))) {
          destination = [];
        } else if (!sourceIsArray && (typeof destination !== "object" || !destination || Array.isArray(destination))) {
          destination = {};
        }

        var _loop = function _loop(key) {
          if (key === "__proto__") {
            return "continue";
          }

          var sourceDict = source;
          var value = sourceDict[key];
          var isObject = typeof value === "object";
          var destDict = destination;
          destDict[key] = isObject && Array.isArray(value) ? value.map(function (v) {
            return Utils.deepExtend(destDict[key], v);
          }) : Utils.deepExtend(destDict[key], value);
        };

        for (var key in source) {
          var _ret = _loop(key);

          if (_ret === "continue") continue;
        }
      }

      return destination;
    }
  }, {
    key: "isDivModeEnabled",
    value: function isDivModeEnabled(mode, divs) {
      return divs instanceof Array ? !!divs.find(function (t) {
        return t.enable && Utils.isInArray(mode, t.mode);
      }) : Utils.isInArray(mode, divs.mode);
    }
  }, {
    key: "divModeExecute",
    value: function divModeExecute(mode, divs, callback) {
      if (divs instanceof Array) {
        var _iterator2 = _createForOfIteratorHelper(divs),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var div = _step2.value;
            var divMode = div.mode;
            var divEnabled = div.enable;

            if (divEnabled && Utils.isInArray(mode, divMode)) {
              Utils.singleDivModeExecute(div, callback);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else {
        var _divMode = divs.mode;
        var _divEnabled = divs.enable;

        if (_divEnabled && Utils.isInArray(mode, _divMode)) {
          Utils.singleDivModeExecute(divs, callback);
        }
      }
    }
  }, {
    key: "singleDivModeExecute",
    value: function singleDivModeExecute(div, callback) {
      var selectors = div.selectors;

      if (selectors instanceof Array) {
        var _iterator3 = _createForOfIteratorHelper(selectors),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var selector = _step3.value;
            callback(selector, div);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      } else {
        callback(selectors, div);
      }
    }
  }, {
    key: "divMode",
    value: function divMode(divs, element) {
      if (!element || !divs) {
        return;
      }

      if (divs instanceof Array) {
        return divs.find(function (d) {
          return checkSelector(element, d.selectors);
        });
      } else if (checkSelector(element, divs.selectors)) {
        return divs;
      }
    }
  }, {
    key: "circleBounceDataFromParticle",
    value: function circleBounceDataFromParticle(p) {
      return {
        position: p.getPosition(),
        radius: p.getRadius(),
        velocity: p.velocity,
        factor: {
          horizontal: NumberUtils_1.NumberUtils.getValue(p.particlesOptions.bounce.horizontal),
          vertical: NumberUtils_1.NumberUtils.getValue(p.particlesOptions.bounce.vertical)
        }
      };
    }
  }, {
    key: "circleBounce",
    value: function circleBounce(p1, p2) {
      var xVelocityDiff = p1.velocity.horizontal;
      var yVelocityDiff = p1.velocity.vertical;
      var pos1 = p1.position;
      var pos2 = p2.position;
      var xDist = pos2.x - pos1.x;
      var yDist = pos2.y - pos1.y;

      if (xVelocityDiff * xDist + yVelocityDiff * yDist >= 0) {
        var angle = -Math.atan2(pos2.y - pos1.y, pos2.x - pos1.x);
        var m1 = p1.radius;
        var m2 = p2.radius;
        var u1 = NumberUtils_1.NumberUtils.rotateVelocity(p1.velocity, angle);
        var u2 = NumberUtils_1.NumberUtils.rotateVelocity(p2.velocity, angle);
        var v1 = NumberUtils_1.NumberUtils.collisionVelocity(u1, u2, m1, m2);
        var v2 = NumberUtils_1.NumberUtils.collisionVelocity(u2, u1, m1, m2);
        var vFinal1 = NumberUtils_1.NumberUtils.rotateVelocity(v1, -angle);
        var vFinal2 = NumberUtils_1.NumberUtils.rotateVelocity(v2, -angle);
        p1.velocity.horizontal = vFinal1.horizontal * p1.factor.horizontal;
        p1.velocity.vertical = vFinal1.vertical * p1.factor.vertical;
        p2.velocity.horizontal = vFinal2.horizontal * p2.factor.horizontal;
        p2.velocity.vertical = vFinal2.vertical * p2.factor.vertical;
      }
    }
  }, {
    key: "rectBounce",
    value: function rectBounce(particle, divBounds) {
      var pPos = particle.getPosition();
      var size = particle.getRadius();
      var bounds = Utils.calculateBounds(pPos, size);
      var resH = rectSideBounce({
        min: bounds.left,
        max: bounds.right
      }, {
        min: bounds.top,
        max: bounds.bottom
      }, {
        min: divBounds.left,
        max: divBounds.right
      }, {
        min: divBounds.top,
        max: divBounds.bottom
      }, particle.velocity.horizontal, NumberUtils_1.NumberUtils.getValue(particle.particlesOptions.bounce.horizontal));

      if (resH.bounced) {
        if (resH.velocity !== undefined) {
          particle.velocity.horizontal = resH.velocity;
        }

        if (resH.position !== undefined) {
          particle.position.x = resH.position;
        }
      }

      var resV = rectSideBounce({
        min: bounds.top,
        max: bounds.bottom
      }, {
        min: bounds.left,
        max: bounds.right
      }, {
        min: divBounds.top,
        max: divBounds.bottom
      }, {
        min: divBounds.left,
        max: divBounds.right
      }, particle.velocity.vertical, NumberUtils_1.NumberUtils.getValue(particle.particlesOptions.bounce.vertical));

      if (resV.bounced) {
        if (resV.velocity !== undefined) {
          particle.velocity.vertical = resV.velocity;
        }

        if (resV.position !== undefined) {
          particle.position.y = resV.position;
        }
      }
    }
  }, {
    key: "animate",
    get: function get() {
      return Utils.isSsr() ? function (callback) {
        return setTimeout(callback);
      } : function (callback) {
        return (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || window.setTimeout)(callback);
      };
    }
  }, {
    key: "cancelAnimation",
    get: function get() {
      return Utils.isSsr() ? function (handle) {
        return clearTimeout(handle);
      } : function (handle) {
        return (window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || window.clearTimeout)(handle);
      };
    }
  }]);

  return Utils;
}();

exports.Utils = Utils;